
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fotos/[slug]",
      function () {
        return require("private-next-pages/fotos/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fotos/[slug]"])
      });
    }
  